/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

const baseAccountsColumns = [
  { Header: "Hsp İd", accessor: "HspId" },
  { Header: "Firma", accessor: "firma" },
  { Header: "İş Ortağı", accessor: "is_ortagi" },
  { Header: "Kayıt Tarihi", accessor: "kayit_tarihi", sortable: true },
  { Header: "Araç Sayısı", accessor: "arac_sayisi" },
  { Header: "Müşteri Tipi", accessor: "musteri_tipi" },
  { Header: "Sektör", accessor: "sektor" },
  { Header: "Cari", accessor: "firma_cari_durumu" },
  { Header: "Adres", accessor: "adres" },
  { Header: "Durum", accessor: "traccar_status" },
  { Header: "İrtibat No", accessor: "irtibat" },
  { Header: "Sabit No", accessor: "sabit_no" },
  { Header: "Vergi No", accessor: "vergi_no" },
  { Header: "Notlar", accessor: "notlar" },
  { Header: "Upd. Tarihi", accessor: "updatedAt" },
  { Header: "UETDS", accessor: "uetds" },
];

// Role göre kolonları filtrele - bayi rolünde "İş Ortağı" kolonunu gizle
export const getAccountsColumns = (userRole) => {
  if (userRole === "bayi") {
    return baseAccountsColumns.filter(col => col.accessor !== "is_ortagi");
  }
  return baseAccountsColumns;
};

// Backward compatibility için default export
export const accountsColumns = baseAccountsColumns;

export default accountsColumns;
